import { get, del, post } from 'services/client'
import { PAGE_LIMIT } from './constants'

export const fetchVendors = ({
  page = 1,
  keyword = '',
  limit = PAGE_LIMIT,
  filters,
}) =>
  get(
    `procurements/vendors?page=${page}&limit=${limit}${
      keyword ? `&search=${keyword}` : ''
    }${
      filters && filters.hasOwnProperty('homologated')
        ? `&homologated=${filters.homologated}`
        : ''
    }`,
  )

export const addVendor = data => post('procurements/invitations', data)

export const removeVendors = ids =>
  del('procurements/vendors', { identities: ids })
